import script from "./AssetsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetsCard.vue?vue&type=script&setup=true&lang=js"

import "./AssetsCard.vue?vue&type=style&index=0&id=12c5fb7a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12c5fb7a"]])

export default __exports__